<template>
  <div class="md-card dash_card md-card-tabs">
    <div>
      <i class="point margin_r"></i>
      {{$t('dashboardLeft.Live.Data')}}
    </div>
    <h4 class="md-card-header font_bold">{{title}}</h4>
    <div class="md-card-content">
      <div class="flex flex_between" v-for="item in infoData" :key="item.id">
        <p class="label_p text_left">
			<RenderTextAsTemplate :text="$t(item.$key)"/>
		</p>
        <p class="flex_1 text_center">{{item.count}}</p>
        <p class="flex_1 text_right" style="min-width: 100px;">
          {{millionFormat(item.amount) }}
          <i
            v-if="isMillion(item.amount)"
          >Mio.</i>
          &nbsp;
          <span>{{dashboardFilter.currency}}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
import RenderTextAsTemplate from "@/components/templates/common/RenderTextAsTemplate.vue";

export default {
	components: { RenderTextAsTemplate },
  inject: {
    theme: {
      //函数式组件取值不一样
      default: () => ({})
    }
  },
  props: {
    infoData: [Object, Array],
    title: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({ dashboardFilter: "dashboardFilter" })
  }
};
</script>